import React from "react";
import UploadProduct from "../components/UploadProduct";

export default function UploadProductPage() {
  return <UploadProduct />;
}
